import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TecladoPin from "../generico/TecladoPin";
import { faCheck, faClose } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import React from "react";
import resumenSocioService from "../../services/resumenGeneral/resumenSocioService";
import Popup from "react-popup";

export const ModalPinTransaccional = ({ id, onSuccess }) => {

    const [pin, setPin] = useState("");
    const tecladoRef = React.createRef();

    const verificarPin = async () => {
        tecladoRef.current.limpiarPin();
        try {
            const { data } = await resumenSocioService.validarPin(pin);
            if (data.codigo === 0) {
                onSuccess && onSuccess();
            } else {
                Popup.queue(notifiPopup("Info", data.mensajeRespuesta));
            }
            setPin("");
        } catch (error) {
            setPin("");
            Popup.queue(notifiPopup("Error", "Error Inesperado, por favor intente nuevamente"));
        }
    }

    function notifiPopup(titulo, mensaje) {
        Popup.create({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Aceptar",
                        className: "success",
                        action: function () {
                            Popup.close();
                        },
                    },
                ],
            },
        });
    }

    return (
        <div className="modal fade" id={id} data-backdrop="static" >
            <div className="modal-dialog modal-sm modal-dialog-centered modal-sm modal-margin ">
                <div className="modal-content">
                    <div className="modal-body d-flex flex-column align-items-center">
                        <TecladoPin
                            pinValue={(pinTransaccional) => { setPin(pinTransaccional); }}
                            label="Ingresá tu Pin Transaccional"
                            ref={tecladoRef}
                        />
                    </div>
                    <div className="modal-footer">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-6">
                                    <button
                                        type="button"
                                        className="btn btn-cu-quintary btn-consulta"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        onClick={() => { tecladoRef.current.limpiarPin() }}
                                    >
                                        <FontAwesomeIcon icon={faClose} /> Cerrar
                                    </button>
                                </div>
                                <div className="col-6">
                                    <button
                                        type="button"
                                        className="btn btn-cu-primary"
                                        data-dismiss="modal"
                                        onClick={verificarPin}
                                        disabled={pin.length < 6}
                                    >
                                        <FontAwesomeIcon icon={faCheck} /> Confirmar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}